var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{attrs:{"gutter":12}},[_c('Col',{attrs:{"span":5}},[_c('stat-menu')],1),_c('Col',{attrs:{"span":19}},[_c('router-view',{attrs:{"name":"statContent"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }